import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18b80fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "personal-data-component" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "custom-radio is-foreign" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  for: "patient-foreign",
  class: "open-sans-font"
}, "Sou estrangeiro(a)", -1))
const _hoisted_5 = { class: "check-buttons" }
const _hoisted_6 = { class: "policy-checkbox-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkboxTerm" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "open-sans-font" }, [
  /*#__PURE__*/_createTextVNode(" Declaro que li e aceito os "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://clinicarx.com.br/termos-de-uso-pacientes",
    class: "span-a-style",
    target: "_blank"
  }, "termos de uso para pacientes "),
  /*#__PURE__*/_createTextVNode("e "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://clinicarx.com.br/politica-de-privacidade/",
    target: "_blank",
    class: "span-a-style"
  }, " política de privacidade"),
  /*#__PURE__*/_createTextVNode(" e que informei corretamente os dados solicitados para uso de serviços de saúde com a Clinicarx. ")
], -1))
const _hoisted_9 = { class: "custom-radio square-radio d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "align-checkbox" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  for: "patient-foreign",
  class: "open-sans-font"
}, "Quero receber informativos sobre como cuidar da minha saúde.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_floating_card = _resolveComponent("floating-card")!
  const _component_terms_of_use_modal = _resolveComponent("terms-of-use-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "8",
      stepTitle: "Informe os demais dados pessoais ",
      nextButtonActive: _ctx.canJumpNext,
      btnNextLabel: "Gerar cartão de resultado",
      onNextStep: _cache[8] || (_cache[8] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[9] || (_cache[9] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _createVNode(_component_alert_box, {
          class: "px-3 mb-24 mt-8",
          info: "",
          stepContent: _ctx.StepContent
        }, null, 8, ["stepContent"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_input, {
            class: "cpf-input",
            type: "text",
            ref: "form-document",
            label: "CPF:",
            inputmode: "numeric",
            placeholder: "Dígitos do CPF",
            validatorType: _ctx.cpfFieldValidations,
            mask: "###.###.###-##",
            disabled: _ctx.patient.isForeigner,
            modelValue: _ctx.patient.document,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patient.document) = $event)),
            required: _ctx.validField,
            requiredSign: ""
          }, null, 8, ["validatorType", "disabled", "modelValue", "required"]),
          _createElementVNode("label", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              name: "patient-foreign",
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patient.isForeigner) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.patient.isForeigner]
            ]),
            _hoisted_4
          ]),
          _createVNode(_component_base_input, {
            type: "text",
            ref: "form-email",
            label: "E-mail:",
            modelValue: _ctx.patient.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patient.email) = $event)),
            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.patient.email = _ctx.patient.email.toLowerCase())),
            placeholder: "exemplo@exemplo.com.br",
            autocapitalize: "off",
            validatorType: _ctx.emailFieldValidations,
            required: "",
            requiredSign: ""
          }, null, 8, ["modelValue", "validatorType"]),
          _createVNode(_component_base_select, {
            type: "text",
            ref: "form-state",
            label: "Estado:",
            placeholder: "Pesquisar estado",
            validatorType: _ctx.stateFieldValidations,
            keyLabel: "nome",
            keyValue: "sigla",
            searchable: "",
            availableOptions: _ctx.states,
            disabled: _ctx.patient.isForeigner,
            onChange: _ctx.getCities,
            modelValue: _ctx.patient.state,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.patient.state) = $event)),
            required: _ctx.validField,
            requiredSign: ""
          }, null, 8, ["validatorType", "availableOptions", "disabled", "onChange", "modelValue", "required"]),
          _createVNode(_component_base_select, {
            type: "text",
            ref: "form-city",
            label: "Cidade:",
            placeholder: "Pesquisar cidade",
            validatorType: _ctx.cityFieldValidations,
            keyLabel: "nome",
            keyValue: "nome",
            searchable: "",
            availableOptions: _ctx.cities,
            disabled: _ctx.patient.isForeigner || _ctx.cities.length == 0,
            modelValue: _ctx.patient.city,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patient.city) = $event)),
            required: _ctx.validField,
            requiredSign: ""
          }, null, 8, ["validatorType", "availableOptions", "disabled", "modelValue", "required"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", {
                class: _normalizeClass(["custom-radio square-radio d-flex align-items-center", { 'has-error': _ctx.mustAccept && !_ctx.patient.accept_terms }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  id: "checkboxTerm",
                  name: "patient-foreign",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.patient.accept_terms) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.patient.accept_terms]
                ]),
                _hoisted_7
              ], 2),
              _hoisted_8
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  name: "patient-foreign",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.patient.emailMkt) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.patient.emailMkt]
                ]),
                _hoisted_10,
                _hoisted_11
              ])
            ], 512), [
              [_vShow, false]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["nextButtonActive"]),
    _createVNode(_component_terms_of_use_modal, { ref: "terms-modal" }, null, 512)
  ]))
}